import React, { Component } from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Footer from '../Footer';
import PageSectionWithWaveContainer from '../PageSectionWithWaveContainer';
import PageHeader from '../PageHeader';
import styles from './styles.sass';

// TODO: Make this have some information
class NotFound extends Component {
  UNSAFE_componentWillMount() {
    const { handleNotFound = () => {} } = this.props;
    handleNotFound(this.props.path);
  }

  render() {
    return (
      <div className={`${styles.pageStartBackground} isV2LegacyPage`}>
        <PageSectionWithWaveContainer
          backgroundClassName={styles.pageHeaderBackground}
        >
          <PageHeader className={styles.notFoundPageHeader} title="404" />
        </PageSectionWithWaveContainer>
        <div className={styles.content}>
          <Grid>
            <Row>
              <Col className="text-center" sm={12}>
                <video
                  autoPlay
                  src="https://d12xoj7p9moygp.cloudfront.net/videos/mr404.mp4"
                />
              </Col>
            </Row>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

export default NotFound;
